import React, { useState } from 'react';
import { Autocomplete, Box, Checkbox, TextField } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

export const FilterSelect = ({
  title,
  setFormData,
  dataField,
  options,
  defaultValue,
  props,
}) => {
  const [checkedItems, setCheckedItems] = useState(defaultValue || []);

  const handleChange = (selectedList) => {
    let finalList = checkedItems;
    console.log('selection', selectedList);
    if (selectedList?.length < 1) {
      setCheckedItems([]);
      setFormData((state) => {
        return {
          ...state,
          [dataField]: null,
        };
      });
      return;
    }

    selectedList?.map((itemSelected) => {
      const isInList = checkedItems?.some(
        (item) => item?.id.toString() === itemSelected?.id.toString()
      );
      if (!isInList) {
        finalList = [...checkedItems, itemSelected];
        setCheckedItems([...checkedItems, itemSelected]);
      }
    });
    checkedItems?.map((item) => {
      const occurences = selectedList.filter(
        (f) => f?.id.toString() === item?.id.toString()
      );
      if (occurences?.length > 1) {
        const list = checkedItems.filter(
          (f) => f?.id.toString() !== item?.id.toString()
        );
        finalList = list;
        setCheckedItems(list);
      }
      if (occurences?.length < 1) {
        finalList = selectedList;
        setCheckedItems(selectedList);
      }
    });

    const valueList = finalList.map((item) => item?.id);
    setFormData((state) => {
      return {
        ...state,
        [dataField]: valueList?.length > 0 ? valueList : null,
      };
    });
  };

  return (
    <Box sx={{ ...props, display: 'flex' }}>
      <Autocomplete
        multiple
        options={options}
        disableCloseOnSelect
        getOptionLabel={(option) => (option?.label ? option?.label : '')}
        value={checkedItems}
        onChange={(event, value) => handleChange(value)}
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                style={{ marginRight: 8 }}
                checked={checkedItems?.some(
                  (item) => item?.id.toString() === option?.id.toString()
                )}
              />
              {option?.display || option?.label}
            </li>
          );
        }}
        style={{ width: '100%' }}
        size="small"
        renderInput={(params) => <TextField {...params} label={title} />}
      />
    </Box>
  );
};
